(() => {
  'use strict';
  if (window.pdlyteLoaded) return;
  window.pdlyteLoaded = true;
  if (document.getElementById('PDLYTEEnglishLocale') && !/^\/en(?:\/|$)/.test(location.pathname) && !document.documentElement.lang.toLowerCase().startsWith('en')) {
    location.replace('/en' + location.pathname + location.search + location.hash);
    return;
  }
  const money = (cents, currency) => new Intl.NumberFormat('en-GB', {style:'currency',currency}).format(Number(cents) / 100);
  const initialise = (scope = document) => {
    scope.querySelectorAll('[data-pd-money]').forEach(el => {el.textContent = money(el.dataset.pdMoney, el.dataset.pdCurrency);});
    scope.querySelectorAll('[data-cf-offers]').forEach(offers => {
      if (offers.dataset.initialised) return;
      offers.dataset.initialised = 'true';
      const root = offers.closest('[data-pdlyte-product]');
      const form = document.getElementById(offers.dataset.formId);
      if (!root || !form) return;
      const currency = offers.dataset.currency;
      const sticky = root.querySelector('[data-cf-sticky]');
      const nativeButton = form.querySelector('[data-st-atc]');
      const requestedPack = new URLSearchParams(location.search).get('pack');
      const requested = requestedPack && Array.from(offers.querySelectorAll('[data-pd-offer]')).find(el => el.dataset.pdOffer === requestedPack);
      if (requested) requested.querySelector('input').checked = true;
      const update = () => {
        const selected = offers.querySelector('input[type="radio"]:checked')?.closest('[data-pd-offer]');
        if (!selected) return;
        const total = Number(selected.dataset.total);
        const items = JSON.parse(selected.querySelector('[data-pd-offer-items]').textContent);
        const planInput = offers.querySelector('[data-pd-selling-plan]');
        if (planInput) {
          planInput.disabled = !items[0].selling_plan;
          planInput.value = items[0].selling_plan || '';
        }
        const consent = offers.querySelector('[data-pd-subscription-consent]');
        if (consent) consent.hidden = !items[0].selling_plan;
        const note = offers.querySelector('[data-pd-purchase-note]');
        if (note) note.textContent = items[0].selling_plan ? 'Pause or cancel anytime. Monthly delivery until canceled.' : (selected.dataset.purchaseType === 'bundle' ? 'One-time bundle. Savings apply automatically in your bag.' : 'One-time purchase. No recurring payments.');
        const saving = Number(selected.dataset.saving || 0);
        const savingPanel = offers.querySelector('[data-pd-selected-saving]');
        if (savingPanel) {
          savingPanel.hidden = saving <= 0;
          savingPanel.querySelector('[data-pd-saving-copy]').textContent = 'You save ' + money(saving,currency) + ' / ' + selected.dataset.savingPercent + '%';
        }
        root.querySelectorAll('[data-st-qty-input]').forEach(input => {input.value = String(items[0].quantity);});
        offers.querySelectorAll('[data-pd-offer]').forEach(label => label.classList.toggle('is-selected', label === selected));
        root.dispatchEvent(new CustomEvent('sternify:price-changed', {bubbles:true, detail:{totalCents:total}}));
        const price = root.querySelector('[data-st-price]');
        if (price) price.textContent = money(total,currency);
        const compare = root.querySelector('[data-st-compare]');
        const regular = Number(selected.dataset.regular || total);
        if (compare) {compare.style.display = regular > total ? '' : 'none';compare.textContent = regular > total ? money(regular,currency) : '';}
        const saleBadge = root.querySelector('[data-st-sale-badge]');
        if (saleBadge) {saleBadge.classList.toggle('is-visible',regular > total);saleBadge.style.display = regular > total ? 'inline-block' : 'none';saleBadge.textContent = regular > total ? 'SAVE ' + selected.dataset.savingPercent + '%' : '';}

        if (sticky) {
          sticky.querySelector('[data-cf-sticky-price]').textContent = money(total,currency);
          sticky.querySelector('[data-cf-sticky-label]').textContent = selected.querySelector('.cf-offer-copy strong').textContent;
          const button = sticky.querySelector('button');
          button.disabled = !nativeButton || nativeButton.disabled;
          button.textContent = nativeButton?.disabled ? 'Unavailable' : 'Add to bag';
        }
      };
      const flavourSelect = offers.querySelector('[data-pd-bundle-flavour]');
      if (flavourSelect) flavourSelect.addEventListener('change', () => {
        const option = flavourSelect.selectedOptions[0];
        for (const offer of offers.querySelectorAll('[data-pd-offer]')) {
          const script = offer.querySelector('[data-pd-offer-items]');
          if (!script) continue;
          const items = JSON.parse(script.textContent);
          items[0].id = Number(option.value);
          if (offer.dataset.purchaseType === 'subscription') items[0].selling_plan = Number(option.dataset.plan);
          script.textContent = JSON.stringify(items);
        }
        update();
      });
      offers.addEventListener('change',update);
      root.addEventListener('change', event => {if (!offers.contains(event.target)) queueMicrotask(update);});
      form.addEventListener('submit', async event => {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (form.dataset.pdSubmitting) return;
        const selected = offers.querySelector('input[type="radio"]:checked')?.closest('[data-pd-offer]');
        if (!selected || nativeButton?.disabled) return;
        const items = JSON.parse(selected.querySelector('[data-pd-offer-items]').textContent);
        const errorPanel = offers.querySelector('[data-pd-purchase-error]');
        const base = window.Shopify?.routes?.root || '/';
        form.dataset.pdSubmitting = 'true';
        if (nativeButton) nativeButton.disabled = true;
        if (errorPanel) errorPanel.hidden = true;
        try {
          const cartUI = await import('@theme/pdlyte-cart');
          const response = await fetch(base + 'cart/add.js', {
            method: 'POST', headers: {'Content-Type':'application/json','Accept':'application/json'},
            body: JSON.stringify({items})
          });
          const added = await response.json();
          if (!response.ok) throw new Error(added.description || 'Could not add this pack. Please try again.');
          const cartResponse = await fetch(base + 'cart.js', {headers:{'Accept':'application/json'}});
          if (!cartResponse.ok) throw new Error('Your items were added. Please check your bag.');
          const cart = await cartResponse.json();
          const retained = (cart.discount_codes || []).filter(item => !item.code.startsWith('PDLYTE-CONCEPT-')).map(item => item.code);
          if (selected.dataset.discountCode) retained.push(selected.dataset.discountCode);
          const discountResponse = await fetch(base + 'cart/update.js', {
            method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
            body:JSON.stringify({discount:retained.join(','),sections:cartUI.sectionIds(),sections_url:location.pathname})
          });
          const updated = await discountResponse.json();
          if (!discountResponse.ok) throw new Error(updated.description || 'Your items were added. Please check your bag.');
          await cartUI.openUpdatedCart(updated);
        } catch (error) {
          if (errorPanel) {errorPanel.textContent = error.message;errorPanel.hidden = false;}
        } finally {
          delete form.dataset.pdSubmitting;
          if (nativeButton) nativeButton.disabled = false;
        }
      },true);
      if (sticky && nativeButton) {
        root._pdlyteSticky = sticky;
        document.body.appendChild(sticky);
        sticky.querySelector('button').addEventListener('click',()=>{if(!nativeButton.disabled) form.requestSubmit();});
        root._pdlyteButtonObserver = new MutationObserver(()=>{sticky.querySelector('button').disabled = nativeButton.disabled;});
        root._pdlyteButtonObserver.observe(nativeButton,{attributes:true,attributeFilter:['disabled']});
        if ('IntersectionObserver' in window) {
          root._pdlyteObserver = new IntersectionObserver(([entry])=>{
            sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
          },{threshold:0});
          root._pdlyteObserver.observe(nativeButton);
        }
      }
      update();
      window.addEventListener('load', update, {once:true});
    });
    scope.querySelectorAll('[data-cf-scroll]').forEach(button=>{
      if(button.dataset.initialised) return;
      button.dataset.initialised='true';
      button.addEventListener('click',()=>button.closest('.cf-community')?.querySelector('.cf-review-strip')?.scrollBy({left:Number(button.dataset.cfScroll)*340,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'}));
    });
  };
  const revealFacts = () => {if(location.hash === '#pdlyte-supplement-facts'){const facts=document.getElementById('pdlyte-supplement-facts');if(facts){facts.open=true;facts.scrollIntoView({block:'start'});}}};
  window.addEventListener('hashchange',revealFacts);
  document.addEventListener('DOMContentLoaded',revealFacts);
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>initialise());
  else initialise();
  document.addEventListener('shopify:section:load',event=>initialise(event.target));
  document.addEventListener('shopify:section:unload',event=>{
    const root=event.target.querySelector('[data-pdlyte-product]');
    root?._pdlyteObserver?.disconnect();root?._pdlyteButtonObserver?.disconnect();root?._pdlyteSticky?.remove();
  });
  const normaliseTabHeadings=()=>document.querySelectorAll('.swiper-pagination-benefit-tabs h1').forEach(heading=>{
    const replacement=document.createElement('h2');
    for(const attribute of heading.attributes) replacement.setAttribute(attribute.name,attribute.value);
    while(heading.firstChild) replacement.appendChild(heading.firstChild);
    heading.replaceWith(replacement);
  });
  normaliseTabHeadings();
  const main=document.getElementById('MainContent');
  if(main)new MutationObserver(normaliseTabHeadings).observe(main,{childList:true,subtree:true});
  document.addEventListener('click',async event=>{
    const button=event.target.closest('[data-pd-cart-add], [data-pd-cart-items]');
    if(!button || button.disabled) return;
    const oldText=button.textContent;
    const feedback=button.closest('.pd-cart-extras, .pd-bundle-card')?.querySelector('[data-pd-cart-feedback]');
    button.disabled=true;
    button.textContent='ADDING…';
    if(feedback)feedback.textContent='';
    try {
      const cartUI = await import('@theme/pdlyte-cart');
      const ids=cartUI.sectionIds();
      const items=button.dataset.pdCartItems ? JSON.parse(button.dataset.pdCartItems) : [{id:Number(button.dataset.pdCartAdd),quantity:1}];
      const result=await fetch((window.Shopify?.routes?.root || '/')+'cart/add.js',{
        method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items,sections:ids,sections_url:location.pathname})
      });
      const data=await result.json();
      if(!result.ok)throw new Error(data.description || 'Could not add this product. Please try again.');
      const cartResponse = await fetch((window.Shopify?.routes?.root || '/')+'cart.js',{headers:{Accept:'application/json'}});
      if(!cartResponse.ok)throw new Error('Your product is in your bag. Open your bag to continue.');
      const cart = await cartResponse.json();
      cart.sections = data.sections;
      await cartUI.openUpdatedCart(cart);
      initialise();
    } catch(error) {
      if(feedback)feedback.textContent=error.message;
    } finally {
      if(button.isConnected){button.disabled=false;button.textContent=oldText;}
    }
  });
})();

(() => {
  'use strict';
  if (window.pdlyteReviewPreviewLoaded) return;
  window.pdlyteReviewPreviewLoaded = true;
  const initialise = (scope = document) => {
    scope.querySelectorAll('[data-pd-review-journal]').forEach(journal => {
      if (journal.dataset.initialised) return;
      journal.dataset.initialised = 'true';
      const rail = journal.querySelector('[data-pd-review-rail]');
      if (!rail) return;
      const cards = Array.from(rail.querySelectorAll('[data-pd-review-card]'));
      const previous = journal.querySelector('[data-pd-review-step="-1"]');
      const next = journal.querySelector('[data-pd-review-step="1"]');
      const position = journal.querySelector('[data-pd-review-position]');
      const reduced = () => matchMedia('(prefers-reduced-motion:reduce)').matches;
      const visibleCards = () => cards.filter(card => !card.hidden);
      const stride = () => (visibleCards()[0]?.getBoundingClientRect().width || 0) + (parseFloat(getComputedStyle(rail).columnGap) || 0);
      const update = () => {
        const visible = visibleCards();
        const step = stride();
        const first = Math.min(visible.length, Math.round(rail.scrollLeft / Math.max(step, 1)) + 1);
        const displayed = Math.max(1, Math.floor((rail.clientWidth + (parseFloat(getComputedStyle(rail).columnGap) || 0)) / Math.max(step, 1)));
        const last = Math.min(visible.length, first + displayed - 1);
        position.textContent = `${first}—${last} / ${visible.length}`;
        previous.disabled = rail.scrollLeft < 2;
        next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
      };
      journal.querySelectorAll('[data-pd-review-filter]').forEach(button => {
        button.addEventListener('click', () => {
          const filter = button.dataset.pdReviewFilter;
          cards.forEach(card => {card.hidden = filter !== 'all' && card.dataset.reviewTopic !== filter;});
          journal.querySelectorAll('[data-pd-review-filter]').forEach(tab => tab.setAttribute('aria-pressed', String(tab === button)));
          rail.scrollTo({left: 0, behavior: 'instant'});
          update();
        });
      });
      journal.querySelectorAll('[data-pd-review-step]').forEach(button => {
        button.addEventListener('click', () => {
          const step = stride();
          const columns = Math.max(1, Math.floor((rail.clientWidth + (parseFloat(getComputedStyle(rail).columnGap) || 0)) / Math.max(step, 1)));
          rail.scrollBy({left: Number(button.dataset.pdReviewStep) * step * columns, behavior: reduced() ? 'instant' : 'smooth'});
        });
      });
      rail.addEventListener('scroll', update, {passive: true});
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(rail);
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise());
  else initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();


